/* The legacy markup uses the same quote transaction as the PDP and landing pages.
 * UI state belongs to each wrapper: the cart page and drawer may quote together. */
var ShippingCalculator = {
    pending: new WeakMap(),
    init: function () {
        if (this._delegated) return;
        this._delegated = true;
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                const variant = event?.data?.variant;
                if (!variant?.id) return;
                document.querySelectorAll('.js-shipping-calculator input[name=variant_id]').forEach((input) => {
                    input.value = variant.id;
                    this.renderReponse('', input.closest('.js-shipping-calculator'));
                });
            });
            if (PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.agendarRecota());
        }
        document.addEventListener('input', (event) => {
            const zip = event.target.closest('.js-zip');
            if (!zip) return;
            const d = zip.value.replace(/\D/g, '').slice(0, 8);
            zip.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
        });
        document.addEventListener('keyup', (event) => {
            const zip = event.target.closest('.js-zip');
            if (!zip || (event.key !== 'Enter' && event.keyCode !== 13)) return;
            event.preventDefault();
            this.checkZip(zip.closest('.shipping__form'));
        });
        document.addEventListener('focusin', (event) => {
            const zip = event.target.closest('.js-zip');
            if (zip && !zip.value) this.renderReponse('', zip.closest('.js-shipping-calculator'));
        });
        document.addEventListener('click', (event) => {
            const button = event.target.closest('.js-shipping-calculator .js-button');
            if (!button) return;
            event.preventDefault();
            this.checkZip(button.closest('.shipping__form'));
        });
    },
    agendarRecota: function () {
        clearTimeout(this._recotaTimer);
        this._recotaTimer = setTimeout(() => this.recotarSeAberto(), 2000);
    },
    recotarSeAberto: async function () {
        const requests = [];
        document.querySelectorAll('.js-shipping-calculator').forEach((wrapper) => {
            // Automatic recalculation never adds a product probe.
            if (wrapper.querySelector('input[name=variant_id]')) return;
            const form = wrapper.querySelector('.shipping__form');
            const zip = wrapper.querySelector('.js-zip');
            const response = wrapper.querySelector('.shipping__response');
            if (!form || !zip || !response || !response.textContent.trim()) return;
            if (zip.value.replace(/\D/g, '').length !== 8) return;
            if (this.pending.has(wrapper)) { this.agendarRecota(); return; }
            requests.push(this.checkZip(form, { automatico: true }));
        });
        await Promise.all(requests);
    },
    checkZip: function (form, opts) {
        if (!form) return Promise.resolve();
        const wrapper = form.closest('.js-shipping-calculator');
        if (!wrapper) return Promise.resolve();
        if (this.pending.has(wrapper)) return this.pending.get(wrapper);
        if (!opts || !opts.automatico) clearTimeout(this._recotaTimer);
        const zip = form.querySelector('.js-zip');
        const digits = zip.value.replace(/\D/g, '');
        if (digits.length !== 8) { this.renderReponse('Digite um CEP válido.', wrapper); return Promise.resolve(); }
        const automatic = !!(opts && opts.automatico);
        const variantInput = form.querySelector('input[name=variant_id]');
        const variantId = variantInput ? Number(variantInput.value) : null;
        if (!automatic) this.renderReponse('', wrapper);
        this.showLoading(true, wrapper);
        const quote = window.WoolieFrete
            ? window.WoolieFrete.cotar(digits, { itemParaCotar: variantId ? () => ({ id: variantId, quantity: 1 }) : undefined })
            : Promise.resolve({ ok: false, motivo: 'rede' });
        const request = quote.then((result) => {
            // The old DOM may have been replaced while Shopify was answering.
            if (!wrapper.isConnected) return;
            if (zip.value.replace(/\D/g, '') !== digits || (variantInput && Number(variantInput.value) !== variantId)) {
                this.renderReponse('Sua seleção mudou. Calcule novamente o frete.', wrapper);
                return;
            }
            if (!result.ok) {
                // A changed cart must never keep an old price as if it were current.
                if (result.motivo === 'alterado') this.agendarRecota();
                const messages = window.WoolieFrete && window.WoolieFrete.mensagens;
                this.renderReponse(messages?.[result.motivo] || 'Não foi possível calcular agora. Tente de novo.', wrapper);
                return;
            }
            const otherItems = (result.carrinho.items || []).some((item) => item.variant_id !== variantId);
            this.renderShippingRates(result.tarifas.map((rate) => rate.raw), result, otherItems, wrapper);
        }).catch(() => {
            this.renderReponse('Não foi possível calcular agora. Tente de novo.', wrapper);
        }).finally(() => {
            this.pending.delete(wrapper);
            this.showLoading(false, wrapper);
        });
        this.pending.set(wrapper, request);
        return request;
    },
    showLoading: function (loading, wrapper) {
        const button = wrapper && wrapper.querySelector('.js-button');
        if (!button) return;
        button.disabled = loading;
        button.classList.toggle('loading', loading);
        button.querySelector('.txt')?.classList.toggle('hidden', loading);
        button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
    },
   renderShippingRates: function(shippingRates, zipInfo, hasOtherItems, wrapper) {


    // Colapsa tarifas duplicadas de mesmo `code` (o carrier às vezes manda a mesma
    // modalidade 2x, uma zerada — "Grátis" fantasma que o checkout não honra). Ver
    // window.freteDedupeRates em assets/frete-prazo.js.
    if (window.freteDedupeRates) shippingRates = window.freteDedupeRates(shippingRates);

    const responseEl = wrapper.querySelector('.shipping__response');

    if (shippingRates !== undefined && shippingRates.length > 0) {
        // Lista por modalidade: "Modalidade · prazo" + preço. Igual à página Duna.
        const list = document.createElement('ul');
        list.className = 'response__rates';

        shippingRates.forEach((rt) => {
            // Entrega Rápida: usa a mensagem pronta do FreteFlow ("Chega hoje/amanhã/<dia>"); null nas demais.
            const chega = (window.fretePrazoChegada && window.fretePrazoChegada(rt)) || '';
            // Texto do prazo centralizado em frete-prazo.js (window.fretePrazoDias),
            // carregado logo antes deste no head. Era montado aqui e também em
            // frete-cotacao.js, com o mesmo código copiado nos dois.
            const dias = chega ? '' : ((window.fretePrazoDias && window.fretePrazoDias(rt)) || '');
            const price = Number(rt.price) === 0 ? 'Grátis' : 'R$ ' + Number(rt.price).toFixed(2).replace('.', ',');

            const li = document.createElement('li');
            const label = document.createElement('span');
            label.appendChild(document.createTextNode((rt.presentment_name || rt.name) + (chega || dias ? ' · ' : '')));
            if (chega) {
                const c = document.createElement('span');
                c.className = 'frete-chega';      // destaque (negrito + raio cinza), ver assets/frete-prazo.css
                c.textContent = chega;
                label.appendChild(c);
            } else if (dias) {
                label.appendChild(document.createTextNode(dias));
            }
            const strong = document.createElement('strong');
            strong.textContent = price;
            li.appendChild(label);
            li.appendChild(strong);
            list.appendChild(li);
        });

        responseEl.textContent = '';
        responseEl.appendChild(list);

        if (hasOtherItems) {
            const note = document.createElement('p');
            note.className = 'shipping_info';
            note.appendChild(document.createTextNode('Prazos consideram todos os itens do seu carrinho.'));
            responseEl.appendChild(note);
        }
    } else {
        this.renderReponse('CEP não localizado. Confirme o prazo de entrega na tela de Check-out.', wrapper);
    }
},


    renderReponse: function (message, wrapper) {
        const output = wrapper && wrapper.querySelector('.shipping__response');
        if (output) output.textContent = message;
    }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => ShippingCalculator.init());
else ShippingCalculator.init();
